enum EViewType {
    
    TEXT = 1,
    TAB,
    ACCORDION,
    NAME_DESCRIPTION

}

export default EViewType;
